"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportReply = exports.reportReview = exports.toggleReviewHelpful = exports.writeReview = exports.fetchReviewsStats = exports.fetchReviews = exports.emailAdmin = exports.details = exports.searchMulti = exports.search = exports.getAppIntegrations = exports.setApiBase = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var GroupTag = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Group"));

var _apiClient = require("../utils/apiClient");

var apiBase = 'ecosystem/v1';
var adminApiBase = 'ecosystem/admin/v1';

var setApiBase = function setApiBase(base) {
  apiBase = base;
};

exports.setApiBase = setApiBase;

var getAppIntegrations = function getAppIntegrations() {
  return (0, _apiClient.getApiClient)().get(apiBase + "/listings/groups/" + GroupTag.APP_INTEGRATIONS + "/tags/published");
};

exports.getAppIntegrations = getAppIntegrations;

var search = function search(query) {
  return (0, _apiClient.getApiClient)().get(apiBase + "/views/search", {
    query: query
  });
};

exports.search = search;

var searchMulti = function searchMulti(queries) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _apiClient.getApiClient)().put(apiBase + "/views/search/multi", (0, _extends2.default)({}, opts, {
    data: queries
  }));
};

exports.searchMulti = searchMulti;

var details = function details(slug) {
  var isPublished = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isAdminPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var base = isAdminPreview ? adminApiBase : apiBase;
  return (0, _apiClient.getApiClient)().get(base + "/views/details/" + slug, {
    query: {
      published: isPublished
    }
  });
};

exports.details = details;

var emailAdmin = function emailAdmin(adminUserId, listingId, permissions) {
  return (0, _apiClient.getApiClient)().post(apiBase + "/permissions/request-from-admin", {
    data: {
      adminUserId: adminUserId,
      listingId: listingId,
      permissions: permissions
    }
  });
};

exports.emailAdmin = emailAdmin;

var fetchReviews = function fetchReviews(queries) {
  return (0, _apiClient.getApiClient)().post(apiBase + "/reviews/query", {
    data: (0, _extends2.default)({}, queries)
  });
};

exports.fetchReviews = fetchReviews;

var fetchReviewsStats = function fetchReviewsStats(offeringId) {
  return (0, _apiClient.getApiClient)().get(apiBase + "/reviews/stats?offeringId=" + offeringId);
};

exports.fetchReviewsStats = fetchReviewsStats;

var writeReview = function writeReview(review) {
  return (0, _apiClient.getApiClient)().post(apiBase + "/reviews", {
    data: review
  });
};

exports.writeReview = writeReview;

var toggleReviewHelpful = function toggleReviewHelpful(reviewId, isHelpful) {
  return (0, _apiClient.getApiClient)().put(apiBase + "/reviews/" + reviewId + "/helpful", {
    data: isHelpful
  });
};

exports.toggleReviewHelpful = toggleReviewHelpful;

var reportReview = function reportReview(_ref) {
  var reviewId = _ref.reviewId,
      reason = _ref.reason,
      comment = _ref.comment;
  return (0, _apiClient.getApiClient)().post(apiBase + "/reviews/" + reviewId + "/report", {
    data: {
      reason: reason,
      comment: comment
    }
  });
};

exports.reportReview = reportReview;

var reportReply = function reportReply(_ref2) {
  var reviewId = _ref2.reviewId,
      replyId = _ref2.replyId,
      reason = _ref2.reason,
      comment = _ref2.comment;
  return (0, _apiClient.getApiClient)().post(apiBase + "/reviews/" + reviewId + "/replies/" + replyId + "/report", {
    data: {
      reason: reason,
      comment: comment
    }
  });
};

exports.reportReply = reportReply;


//////////////////
// WEBPACK FOOTER
// ./js/clients/ecosystemClient.js
// module id = 100
// module chunks = 209 210 211 212